import { FC } from 'react';

import { useActionInput } from '../context';
import { RichMediaInput, RichMediaInputProps } from './editor/rich-media-input';

export type ActionTextProps = Omit<RichMediaInputProps, 'editor' | 'uniqueId'>;

/**
 * The rich media input for user text interaction
 */
export const ActionText: FC<ActionTextProps> = (props) => {
	const { editor, uniqueId } = useActionInput();

	return <RichMediaInput editor={editor} uniqueId={uniqueId} {...props} />;
};

ActionText.displayName = 'ActionText';
